import React, { useState, useEffect, useContext, useRef, useCallback, } from 'react';
import { useTranslation } from 'react-i18next';
import TextButton from '../../../Buttons/TextButton';
import CloseBig from '../../../Icons/CloseBig';
import PlainButtonOrLink from '../../../Buttons/PlainButtonOrLink';
import { IconSize } from '../../../Icons/IconWrap';
import { ReverseTheme, ThemeContext, ThemeOptions, } from '@wix/da-react-context/pkg/ThemeContext';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import PopperContent from '../../../Popover/_partials/PopperContent';
import MediaService from '../../../utils/DeviationMediaService';
import { getDeviationType, isFileLargerThanSize, scaleToSize, } from '../../../DeviationViews/_helpers';
import noop from '../../../utils/noop';
import { DeviationTypes } from '../../../types/deviation';
import { useOnOutsideClick } from '../../../utils/hooks/useOnOutsideClick';
import { scrollIntoViewInViewportCenter } from '../../../utils/scrollIntoViewWithHeader';
import s from './HoroscopeTooltip.scss';
// we gonna be breaking all the rules in here to keep things nice and easy to
// delete once the event is over... DONT DO THIS AT HOME KIDS
function getContentSize(deviation, width, height) {
    /* here we copypasta sizing from image views... */
    if (getDeviationType(deviation) === DeviationTypes.IMAGE) {
        var zoomedFile = MediaService.getLargestFullview(deviation);
        var isHuge = !!zoomedFile && isFileLargerThanSize(zoomedFile, width, height);
        var file = isHuge
            ? MediaService.getFullviewForSize(deviation, width, height)
            : zoomedFile;
        return file ? scaleToSize(file, { width: width, height: height }) : { width: width, height: height };
    }
    return { width: width, height: height };
}
var HoroscopeTooltip = function (_a) {
    var _b;
    var deviation = _a.deviation, width = _a.width, height = _a.height;
    var theme = useContext(ThemeContext);
    var isMobile = useContext(MobileContext);
    var t = useTranslation().t;
    var _c = useState(false), isDismissed = _c[0], setDismissed = _c[1];
    var dismiss = useCallback(function () { return setDismissed(true); }, []);
    var tooltipRef = useRef(null);
    useOnOutsideClick(tooltipRef, dismiss);
    var scrollToFortune = useCallback(function () {
        var fortune = document.querySelector('[data-hook=ART_FORTUNE]');
        if (fortune) {
            scrollIntoViewInViewportCenter(fortune, isMobile);
        }
        setDismissed(true);
    }, [isMobile]);
    useEffect(function () {
        setDismissed(false);
    }, [deviation.deviationId]);
    if (!((_b = deviation.extended) === null || _b === void 0 ? void 0 : _b.fortune) || isDismissed) {
        return null;
    }
    return (React.createElement("div", { className: s['root'] },
        React.createElement("div", { className: s['content-area'], style: getContentSize(deviation, width, height) },
            React.createElement("div", { className: s['anchor'] },
                React.createElement(PopperContent, { rootRef: noop, noMaxWidth: true, style: {}, placement: "top-start", scheduleUpdate: noop, arrowProps: { ref: noop, style: { left: 30 } } },
                    React.createElement("div", { ref: tooltipRef },
                        React.createElement(ReverseTheme, { className: s['tooltip'] },
                            React.createElement("img", { className: s['icon'], alt: "", src: "https://st.deviantart.net/eclipse/global/svg/artfortune-tooltip.svg" }),
                            React.createElement("div", null,
                                React.createElement("div", { className: s['text'] }, t('aprilFools.tooltip.text')),
                                React.createElement(TextButton, { variant: theme === ThemeOptions.LIGHT
                                        ? 'approval-green'
                                        : 'unbranded', size: "medium", className: s['button'], onClick: scrollToFortune }, t('aprilFools.tooltip.cta'))),
                            React.createElement(PlainButtonOrLink, { className: s['close'], onClick: function () { return setDismissed(true); } },
                                React.createElement(CloseBig, { size: IconSize.NANO })))))))));
};
HoroscopeTooltip.displayName = 'HoroscopeTooltip';
export default HoroscopeTooltip;
//# sourceMappingURL=HoroscopeTooltip.js.map